import React, { useState } from "react";
import './Contact.css'; // Make sure the CSS is imported
import emailjs from 'emailjs-com';

const ContactComponent = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.message) {
      setStatus("Please fill in all fields.");
      return;
    }

    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      message: formData.message,
    };

    // Sending the email using EmailJS
    emailjs
      .send(
        'service_8e6lz38', // EmailJS Service ID
        'template_dv0rlff', // EmailJS Template ID
        templateParams,
        'gk2fEqq_q4XIic39p' // EmailJS User ID
      )
      .then(
        (response) => {
          setStatus("Message sent successfully!");
          setFormData({ name: "", email: "", message: "" }); // Reset form fields
        },
        (error) => {
          setStatus("Failed to send message. Please try again.");
        }
      );
  };

  return (
    <div className="contact-container">
      <div className="contact-hero-image-wrapper contact-wrapper">
        <div className="contact-bg-img">
          <img src="../../Images/homepageimages/Ofis1.jpg" alt="Hero" />
        </div>
        <div className="contact-front-img">
          <img src="../../Images/homepageimages/Ofis1.jpg" alt="Hero Front" />
        </div>
      </div>
      <div className="contact-content-wrapper contact-wrapper">
        <header>
          <div className="contact-h1" style={{ display: "flex", gap: "100px" }}>
            <h1>GET IN TOUCH <br /> WITH US</h1>
            <div className=""></div>
            <footer style={{ textAlign: "right" }}>
              <p>Offices:</p>
              <span>Uae, Sharjah</span>
              <br />
              <span>Qatar, Westbay</span>
            
              <br />
              <span>Istanbul, Nish Adalar</span>
              <br />
              <br />
              <p>Contact:</p>
              <span>info@atoz.qa</span>
              <br />
              <span style={{ fontFamily: "wasted-vindey" }}>+974 3320 3072</span>
            </footer>
          </div>

          <div className="contact-form-wrapper">
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: "column", alignItems: "flex-end" }}>
              <div style={{ display: 'flex', flexDirection: 'column', width: "100%", gap: "10px" }}>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Name, Surname"
                  style={{ border: "2px solid black" }}
                />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Email Address"
                  style={{ border: "2px solid black" }}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "row", width: "100%", marginTop: "20px", marginBottom: "10px", border: "2px solid black", height: "80px" }}>
                <input
                  type="text"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  placeholder="Give Us a Message"
                />
              </div>
              <button type="submit" style={{ width: "150px" }}>SEND</button>
            </form>
            {status && <p>{status}</p>}
            <p>
              To discuss your project in further detail,
              <br />
              or for information about the services we offer.
            </p>
          </div>
        </header>
      </div>
    </div>
  );
};

export default ContactComponent;
